module.exports = __webpack_public_path__ + "img/paul.a684216d.png";